import { Skeleton, SkeletonBox } from "skullet/react";
import { SampleDogCard } from "@/features/listings";
import { STREAMED_FEED_ROW_COUNT } from "./feedRows";
import {
    ROW_CLASS,
    ROW_LIST_CLASS,
    ROW_TITLE_TEXT_CLASS,
    rowListItemClass,
    SECTION_CONTENT_CLASS,
} from "./listingRowLayout";

export const FEED_LOADING_COPY = "Sniffing out pups near you…";

const FEED_ROW_CELLS = 5;

function ListingRowSkeleton({ row }: { row: number }) {
    const sniffs = row === 0;
    return (
        <div aria-hidden="true" inert className={ROW_CLASS}>
            <div
                className={`relative flex h-lh items-center ${ROW_TITLE_TEXT_CLASS}`}
            >
                <span
                    data-feed-title-bar={sniffs ? "" : undefined}
                    className="block h-4 w-48 md:h-5 md:w-64"
                >
                    <SkeletonBox width="100%" height="100%" radius={999} />
                </span>
                {sniffs ? (
                    <p
                        data-feed-sniff=""
                        className="absolute inset-y-0 left-0 flex items-center whitespace-nowrap text-doberman-black/55"
                    >
                        {FEED_LOADING_COPY}
                    </p>
                ) : null}
            </div>
            <Skeleton loading>
                <div className={`${ROW_LIST_CLASS} max-md:overflow-hidden`}>
                    {Array.from({ length: FEED_ROW_CELLS }, (_, cell) => (
                        <div key={cell} className={rowListItemClass(cell)}>
                            <SampleDogCard />
                        </div>
                    ))}
                </div>
            </Skeleton>
        </div>
    );
}

export function FeedSkeleton() {
    return Array.from({ length: STREAMED_FEED_ROW_COUNT }, (_, row) => (
        <div key={row} data-feed-skeleton="" className={SECTION_CONTENT_CLASS}>
            <ListingRowSkeleton row={row} />
        </div>
    ));
}
